/** Fetches a remote image and returns it as a base64 data URL so html2canvas can rasterize it; undefined on failure. */
export const fetchAsDataUrl = async (
  url: string
): Promise<string | undefined> => {
  if (url.startsWith("data:")) return url;
  try {
    const blob = await (await fetch(url)).blob();
    return await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch {
    return undefined;
  }
};
